import { BulkInvitationContextState, initialBulkInviteContextState } from './state'
import {
  ActionType,
  BulkInviteContextActions,
  CsvClientVerificationCompletedContext,
  CsvClientVerificationStartedContext,
  CsvServerVerificationCompletedContext,
  CsvServerVerificationStartedContext,
  InvitationCompletedContext,
  InvitationResultChangedContext,
  ProcessedInvitationCountContext,
  ResetContext,
  StartInvitationLoadingContext,
} from './actions'
import { CheckedCsvInviteUser, CsvInviteUser, UserInvitationResult } from '../../../../store/auth/auth'

export function bulkInvitationContextReducer(state: BulkInvitationContextState, action: BulkInviteContextActions): BulkInvitationContextState {
  switch (action.type) {
    case ActionType.CSV_FILE_UPLOADED:
      return {
        ...state,
        csv: {
          ...state.csv,
          fileContent: action.payload,
        },
      }
    case ActionType.CSV_CLIENT_VERIFICATION_STARTED:
      return {
        ...state,
        csv: {
          ...state.csv,
          clientSideVerificationLoading: true,
        },
      }
    case ActionType.CSV_CLIENT_VERIFICATION_COMPLETED:
      return {
        ...state,
        csv: {
          ...state.csv,
          clientSideVerificationLoading: false,
          clientSideVerificationCompleted: true,
          clientSideVerificationError: action.payload.errorMessage,
        },
        users: action.payload.users,
      }
    case ActionType.CSV_SERVER_VERIFICATION_STARTED:
      return {
        ...state,
        csv: {
          ...state.csv,
          serverSideVerificationLoading: true,
        },
      }
    case ActionType.CSV_SERVER_VERIFICATION_COMPLETED:
      return {
        ...state,
        csv: {
          ...state.csv,
          serverSideVerificationLoading: false,
          serverSideVerificationCompleted: true,
          serverSideVerificationErrors: action.payload.errorMessages,
        },
        users: action.payload.users,
      }
    case ActionType.INVITE_START_INVITATION_LOADING:
      return {
        ...state,
        invite: {
          ...state.invite,
          isInvitationLoading: true,
        },
      }
    case ActionType.INVITE_PROCESSED_INVITATION_COUNT_CHANGED:
      return {
        ...state,
        invite: {
          ...state.invite,
          processedInvitationCount: action.payload,
        },
      }
    case ActionType.INVITE_RESULT_CHANGED:
      return {
        ...state,
        invite: {
          ...state.invite,
          results: action.payload,
        },
      }
    case ActionType.INVITE_COMPLETED:
      return {
        ...state,
        invite: {
          ...state.invite,
          completed: true,
          isInvitationLoading: false,
        },
      }
    case ActionType.RESET:
      return initialBulkInviteContextState
    default:
      return state
  }
}

export const csvClientVerificationStarted = (): CsvClientVerificationStartedContext => ({
  type: ActionType.CSV_CLIENT_VERIFICATION_STARTED,
})

export const csvClientVerificationCompleted = (users: CsvInviteUser[], errorMessage: string | null): CsvClientVerificationCompletedContext => ({
  type: ActionType.CSV_CLIENT_VERIFICATION_COMPLETED,
  payload: {
    users,
    errorMessage,
  },
})

export const csvServerVerificationStarted = (): CsvServerVerificationStartedContext => ({
  type: ActionType.CSV_SERVER_VERIFICATION_STARTED,
})

export const csvServerVerificationCompleted = (users: CheckedCsvInviteUser[], errorMessages: string[]): CsvServerVerificationCompletedContext => ({
  type: ActionType.CSV_SERVER_VERIFICATION_COMPLETED,
  payload: {
    users,
    errorMessages,
  },
})

export const startInvitationLoading = (): StartInvitationLoadingContext => ({
  type: ActionType.INVITE_START_INVITATION_LOADING,
})

export const processedInvitationCountChanged = (processedCount: number): ProcessedInvitationCountContext => ({
  type: ActionType.INVITE_PROCESSED_INVITATION_COUNT_CHANGED,
  payload: processedCount,
})

export const invitationResultChanged = (invitedUsers: UserInvitationResult[]): InvitationResultChangedContext => ({
  type: ActionType.INVITE_RESULT_CHANGED,
  payload: invitedUsers,
})

export const invitationCompleted = (): InvitationCompletedContext => ({
  type: ActionType.INVITE_COMPLETED,
})

export const reset = (): ResetContext => ({
  type: ActionType.RESET,
})
